import(/* webpackMode: "eager" */ "/codebuild/output/src1279907499/src/app/home/page.tsx");
